import { VesselsNotFoundSearchIcon } from "../../shared/Icons/VesselsNotFoundSearchIcon";
import {
  certificateAtomsAtom,
  hasSearchedForCertificatesAtom,
  themeAtom,
  vesselDropdownInputAtom,
} from "../../shared/atoms";
import { Certificate } from "../models/certificates.interfaces";
import { CertificatesTableHeader } from "./CertificatesTableHeader";
import { CertificatesTablePlaceholder } from "./CertificatesTablePlaceholder";
import { CertificatesTableRow } from "./CertificatesTableRow";
import { useAtomValue } from "jotai";
import { twMerge } from "tailwind-merge";

interface CertificatesTableProps {
  openDownloadModal: (certificates: Certificate[]) => void;
  searchDocs: () => void;
}

export function CertificatesTable({ openDownloadModal, searchDocs }: CertificatesTableProps) {
  const theme = useAtomValue(themeAtom);
  const certificateAtoms = useAtomValue(certificateAtomsAtom);
  const hasCertificates = certificateAtoms.length > 0;
  const hasSearchedForCertificates = useAtomValue(hasSearchedForCertificatesAtom);

  if (hasCertificates) {
    return (
      <div className="overflow-y-auto">
        <table className={twMerge("min-w-full border-collapse", theme.home.tailwind.pageBackground)}>
          <CertificatesTableHeader />
          <tbody className={theme.uwhcAssistant.tableRowEven}>
            {certificateAtoms.map((certificateAtom, index) => (
              <CertificatesTableRow
                certificateAtom={certificateAtom}
                key={certificateAtom.toString()}
                openModal={openDownloadModal}
                searchDocs={searchDocs}
                index={index}
              />
            ))}
          </tbody>
        </table>
      </div>
    );
  } else if (hasSearchedForCertificates) {
    return <NoCertificatesFound />;
  } else {
    return <CertificatesTablePlaceholder />;
  }
}

function NoCertificatesFound() {
  const vessel = useAtomValue(vesselDropdownInputAtom);
  const theme = useAtomValue(themeAtom);

  return (
    <div
      className={twMerge(
        "flex h-full w-full items-center justify-center overflow-auto",
        theme.home.tailwind.textDefault,
      )}
    >
      <div className="flex h-48 w-[400px] flex-col items-center gap-4 text-center">
        <VesselsNotFoundSearchIcon
          outerFill={theme.myVesselsTable.searchIcon.outerFill}
          innerFill={theme.myVesselsTable.searchIcon.innerFill}
          glyphFill={theme.myVesselsTable.searchIcon.glyphFill}
          size={105}
        />
        <span>
          We couldn't find any documents matching your search criteria. Try changing your search parameter or{" "}
          <a
            href={`/documents/request?vesselName=${vessel?.vesselName}&vesselCode=${vessel?.code}&imoNumber=${vessel?.imoNumber}`}
            className="font-bold text-[#1F8475]"
          >
            request documents
          </a>
          {"."}
        </span>
      </div>
    </div>
  );
}
